module.exports = __webpack_public_path__ + "img/1w.0a8f32e8.png";